import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AndromedaButtonTypes } from '@upassignations/core';

@Component({
  selector: 'lib-popup-dialog',
  templateUrl: './popup-dialog.component.html',
  styleUrl: './popup-dialog.component.scss',
  imports: [CommonModule],
})
export class PopupDialogComponent implements OnInit {
  message;
  type: PopupType;
  choice = false;
  actions: any[];
  andromedaButtonTypes = AndromedaButtonTypes;
  popUpTypes = PopupType;

  constructor(
    // eslint-disable-next-line no-unused-vars
    public dialogRef: MatDialogRef<PopupDialogComponent>,
    // eslint-disable-next-line no-unused-vars
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.message = this.data.message;
    this.type = this.data.type;
    this.actions = this.data.actions ? this.data.actions : [];
  }

  /**
   * Ferme le popup
   *
   * @param {*} choice
   * @memberof PopupDialogComponent
   */
  closePopUp(choice): void {
    this.dialogRef.close({
      choice,
    });
  }
}

export enum PopupType {
  // eslint-disable-next-line no-unused-vars
  Alert = 'alert',
  // eslint-disable-next-line no-unused-vars
  Info = 'info',
  // eslint-disable-next-line no-unused-vars
  Error = 'error',
  // eslint-disable-next-line no-unused-vars
  Success = 'success',
}
